import React, { Component, cloneElement, PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  getTempConnections,
  changeCollectionItemValue,
  sendTempConnections,
  addAnotherConnection,
  removeInvitation,
  cancelCurrentCSVSelection,
  cancelCSVHeaderSelection,
  convertFromCSV,
  isPersistedFromServer,
  sendEmailToTempConnectionsStarting,
  sendEmailToTempConnections,
  changeEmailValue,
  acceptCurrentCSVSelection,
  deleteTempConnections,
} from '../../stores/temp-connections/temp-connections-actions';

class TempConnectionContainer extends Component {

  componentWillMount = () => {
    const { dispatch } = this.props;
    return dispatch(getTempConnections());
  };

  changeCollectionItemValue = (mapKey, valueKey, value) => {
    const { dispatch } = this.props;
    return dispatch(changeCollectionItemValue(mapKey, valueKey, value));
  };

  isPersistedFromServer = () => {
    const { dispatch } = this.props;
    return dispatch(isPersistedFromServer());
  };

  sendEmailToTempConnections = (emailValue) => {
    const { dispatch } = this.props;
    dispatch(sendEmailToTempConnectionsStarting());
    return dispatch(sendEmailToTempConnections(emailValue));
  };

  changeEmailValue = (value) => {
    const { dispatch } = this.props;
    return dispatch(changeEmailValue(value));
  };

  sendTempConnections = (connections) => {
    const { dispatch } = this.props;
    dispatch(sendEmailToTempConnectionsStarting());
    return dispatch(sendTempConnections(connections));
  };

  addAnotherConnection = () => {
    const { dispatch } = this.props;
    return dispatch(addAnotherConnection());
  };

  removeInvitation = (mapKey) => {
    const { dispatch } = this.props;
    return dispatch(removeInvitation(mapKey));
  };

  cancelCSVHeaderSelection = () => {
    const { dispatch } = this.props;
    return dispatch(cancelCSVHeaderSelection());
  };

  acceptCurrentCSVSelection = () => {
    const { dispatch } = this.props;
    return dispatch(acceptCurrentCSVSelection());
  };

  convertFromCSV = (fileContents) => {
    const { dispatch } = this.props;
    return dispatch(convertFromCSV(fileContents));
  };

  deleteTempConnections = () => {
    const { dispatch } = this.props;
    return dispatch(deleteTempConnections());
  };

  cancelCurrentCSVSelection = () => {
    const { dispatch } = this.props;
    return dispatch(cancelCurrentCSVSelection());
  };

  render() {
    const { children, ...props } = this.props;
    const extraProps = {
      changeCollectionItemValue: this.changeCollectionItemValue,
      sendTempConnections: this.sendTempConnections,
      addAnotherConnection: this.addAnotherConnection,
      removeInvitation: this.removeInvitation,
      cancelCSVHeaderSelection: this.cancelCSVHeaderSelection,
      acceptCurrentCSVSelection: this.acceptCurrentCSVSelection,
      cancelCurrentCSVSelection: this.cancelCurrentCSVSelection,
      isPersistedFromServer: this.isPersistedFromServer,
      sendEmailToTempConnections: this.sendEmailToTempConnections,
      changeEmailValue: this.changeEmailValue,
      deleteTempConnections: this.deleteTempConnections,
      convertFromCSV: this.convertFromCSV,
      ...props,
    };
    return (
      <div className="l-app-content new-connection-container">
        {children ? cloneElement(children, extraProps) : undefined}
      </div>
    );
  }
}

TempConnectionContainer.propTypes = {
  dispatch: PropTypes.func,
  children: PropTypes.any,
};

const select = (state) => {
  return {
    tempConnections: state.tempConnections,
  };
};

export default connect(select)(TempConnectionContainer);



// WEBPACK FOOTER //
// ./src/app/components/temp-connections/temp-connections.jsx